// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"PriceAmountInput_inputContainer__Azhil","dollarSign":"PriceAmountInput_dollarSign__43gQM"};